import { FC } from 'react';

const VeganIcon: FC<{
  fill?: string;
  height?: number;
  width?: number;
}> = ({ fill = '#3C3F43', height = 16, width = 16 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_42381_16243)">
        <path
          d="M15.3869 0.3262C15.3802 0.242495 15.3421 0.164409 15.2803 0.107554C15.2185 0.0506991 15.1375 0.0192639 15.0536 0.019533C14.8536 0.019533 10.0469 0.0195329 8.38689 2.07287C7.72794 2.77819 7.30867 3.67367 7.18895 4.63146C7.06922 5.58925 7.25516 6.56038 7.72022 7.4062C8.47587 5.79292 9.54038 4.34338 10.8536 3.13953C10.9862 3.023 11.1597 2.96387 11.336 2.97511C11.5122 2.98636 11.6768 3.06707 11.7936 3.19953C11.8644 3.28473 11.9145 3.38511 11.9402 3.49287C11.8045 3.50741 11.6765 3.56325 11.5736 3.65287C8.84022 5.99953 7.39356 9.89953 6.66689 12.5395C6.58022 11.9929 6.47356 11.3929 6.34022 10.7729C5.58689 6.99953 4.03356 2.19287 1.06689 0.852866C1.01088 0.827586 0.949075 0.817955 0.888033 0.824998C0.826992 0.832041 0.769 0.855495 0.720223 0.892866C0.672625 0.929925 0.636218 0.979439 0.615037 1.03592C0.593857 1.0924 0.588729 1.15365 0.600223 1.21287C1.6736 6.15812 3.53514 10.8986 6.11356 15.2529C6.11626 15.3712 6.15041 15.4867 6.2125 15.5874C6.2746 15.6882 6.3624 15.7706 6.46689 15.8262C6.49701 15.8731 6.53842 15.9118 6.58734 15.9386C6.63626 15.9654 6.69112 15.9794 6.74689 15.9795C6.77992 15.9858 6.81385 15.9858 6.84689 15.9795C6.90191 15.967 6.95118 15.9365 6.98689 15.8929C7.10357 15.8552 7.20762 15.7862 7.2876 15.6933C7.36758 15.6004 7.42039 15.4872 7.44022 15.3662C7.82192 13.0593 8.51959 10.816 9.51356 8.69953C9.73334 8.74087 9.95659 8.76096 10.1802 8.75953C11.5869 8.75953 13.0069 7.91953 14.0602 6.3662C15.6602 3.9462 15.4002 0.472866 15.3869 0.3262Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_42381_16243">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default VeganIcon;
